import './style.css'

export function Input({ Text, htmlFor, type, id, name, value, onChange, required, className, placeholder }){
  
  return (
    <div className="form-group">
      <label htmlFor={htmlFor}>{Text}</label>
        <input
          type={type}
          id={id}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          className={className}
          placeholder={placeholder}
        />
    </div>
  )
}